import { render } from "./PlaceholderSelection.vue?vue&type=template&id=b5101d9a"
import script from "./PlaceholderSelection.vue?vue&type=script&lang=js"
export * from "./PlaceholderSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__